import React, { useRef, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import moment from "moment";
import "./new_a_propos.css";

import WhyUsLayout from './WhyUsLayout.js';
import LogoCloud from './LogoCloud.js';
import VisionSection from './VisionSection.js';
import KeyMetrics from './KeyMetrics.js';
import Features from './Features.js';
import AboutUsSection from './block_stat/AboutUsSection.js';

const New_C_A_Propos_2025 = (props) => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

    }, []);

    return (

        <div className="new_a_propos_2025">
            <Helmet>
                <title>Éditeur Français de logiciels de gestion pour organismes de formation - Gestion administrative, CRM, E-Learning, Marketplace</title>
                <meta name="description" content="Éditeur Français de logiciels pour organismes de formation. Avec notre solution Tout-en-Un, Nous automatisons les étapes Qualiopi (Inscription, Documents personnalisés, Les émargements sécurisés, Les évaluations, etc). Votre Le bilan pédagogique et financier est généré automatiquement." />
                <meta name="robots" content="index,follow" />
                <meta name="title" content="Éditeur Français de logiciels de gestion pour organismes de formation - Gestion administrative, CRM, E-Learning, Marketplace" />
                <link rel="canonical" href={window.location.href} />

            </Helmet>

            <div className="fonctionnalite_Background">
                <div className="title_and_cat">

                    <div className="title_and_cat_title">
                        <div className="title_and_cat_title_text1">
                            Votre partenaire pour des formations  <br />& une gestion simplifiée.
                        </div>

                        <div className="title_and_cat_title_text2">
                            MySy Training combine innovation et expertise pour transformer la manière dont vous formez et gérez votre établissement.   </div>
                    </div>

                    <div className="title_and_cat_title_cat">

                        <div className="title_and_cat_title_cat_bton_demo" onClick={(e) => {
                            e.preventDefault();
                            var date2 = new Date();
                            const format2 = "YYYY-MM";
                            var dateTime2 = moment(date2).format(format2);
                            window.open(
                                "https://calendly.com/mysytraining/demo-mysy-training-solution?month=" + String(dateTime2),
                                '_blank'
                            );
                        }}>
                            <nav className="title_and_cat_title_cat_bton_demo_txt">  Réserver une démo </nav>
                        </div>

                        <div className="title_and_cat_title_cat_bton_tarif" onClick={(e) => {

                            window.open(
                                "/contact/",
                                '_self'
                            );
                        }}>
                            <nav className="title_and_cat_title_cat_bton_tarif_txt"> Nous contacter </nav>
                        </div>
                    </div>
                </div>
            </div>

            <WhyUsLayout />

            <LogoCloud />

            <VisionSection />

            {/*  <KeyMetrics /> */}

            <Features />


            <AboutUsSection />

        </div>
    )

}


export default New_C_A_Propos_2025;